<template>
	<div>
		<FormGroup label="Virksomhed" alias="organization" label-cols-md="3" v-slot:default="props" scope="relation">
			<OptifySelect :options="organizations" v-model="entity.organizationId" :multiple="false" :show-labels="false"
				@search="search" @select="select" label="text" track-by="id" :internal-search="false" autocomplete="off">
			</OptifySelect>

			<input type="hidden" v-validate="'required'" v-model="entity.organizationId" data-vv-as="Virksomhed"
				:class="{ 'is-invalid': !props.state }" name="organization" data-vv-scope="relation" />
		</FormGroup>
	</div>
</template>

<script>

export default {
	data: () => ({
		organizations: []
	}),
	inject: ['$validator'],
	components: {},
	computed: {},
	watch: {},
	props: ["entity"],
	methods: {
		search(query) {			
			this.$http.post("/api/multi-select/organizations", {
				search: query,
				value: this.entity.organizationId,
				values: [],
				taggable: true
			}).then(x => {
				this.organizations = x.data;
			});
		},
		select(item) {
			if (item.isNew === true) {
				this.$http.post("/api/multi-select/organizations/create", {
					name: item.text
				}).then(x => {
					this.entity.organizationId = x.data.id;
					this.search();
				});
			}
		},
		ok() {
			this.$validator.validate("relation.*").then(valid => {
				if (valid) {
					this.$emit("close");
				}
			});
		},
		cancel() {
			this.$emit("close");
		}
	},
	created() {
		this.search();
	},
	mounted() {},
};
</script>